import { getStudentNumberFromSession } from '../utils/helpers/others/SessionHelper'
import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getIslandScores = async () => {
    let studentNumber = getStudentNumberFromSession();

    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Trait/GetTraitGroupScores/${studentNumber}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getWeatherConditions = async () => {
    try {
        const result = await axios.get('https://api.data.gov.sg/v1/environment/2-hour-weather-forecast');
        const weatherRes = JSON.parse(result.request.response)

        return {
            current_datetime: weatherRes.items[0].timestamp,
            condtion: weatherRes.items[0].forecasts[11].forecast
        }
    } catch (error) {
        console.error(error);
        return {
            current_datetime: Date.now,
            condtion: "Error"
        }
    }
}

export const changeStudentConsent = async (studentNumber) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/ChangeStudentConsented/${studentNumber}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const submitSelectedCluster = (studentNumber, cluster) => {
    var bodyFormData = new FormData();
    bodyFormData.set('studentNumber', studentNumber);
    bodyFormData.set('cluster', cluster);

    return axios({
        method: 'post',
        url: `${process.env.WEB_API}Student/SelectCluster`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getDailyChestClaimDate = async (studentNumber) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/getDailyChestClaimDate/${studentNumber}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const claimDailyChest = (studentNumber) => {
    var bodyFormData = new FormData();
    bodyFormData.set('studentNumber', studentNumber);

    return axios({
        method: 'post',
        url: `${process.env.WEB_API}Student/ClaimDailyChest`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getIslandStatisticsByStudentNumber = async (studentNumber) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/GetIslandStatisticsByStudentNumber/${studentNumber}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const GetExtraLevelAssetByTraitGroupId = async (traitGroupId) => {

    let studentNumber = getStudentNumberFromSession();

    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/GetExtraLevelAssetByStudentNumber/${studentNumber}/${traitGroupId}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};